/**
 * Additional configuration to explanation query.
 */
export interface ExplanationOptions {
    /**
     * Scope explanation to specific group by key.
     */
    groupKey: string;
}
